import React from "react";

class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[LazyErrorBoundary] Error al cargar sección:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: this.props.minHeight || "180px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            margin: "16px auto",
            backgroundColor: "#fff5f5",
            border: "1px solid #fed7d7",
            borderRadius: "8px",
            color: "#c53030",
            textAlign: "center",
            maxWidth: "600px",
          }}
        >
          <p style={{ fontWeight: 600, marginBottom: "8px" }}>
            No se pudo descargar esta sección debido a un problema de conexión.
          </p>
          <button
            type="button"
            onClick={this.handleRetry}
            style={{
              backgroundColor: "#b5179b",
              color: "#ffffff",
              border: "none",
              padding: "8px 18px",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default LazyErrorBoundary;
